import React from "react";

import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Constant from "../../util/constant";
import "./404.css";

/**
 * A functional component that renders a 404 page not found error page.
 * @param {object} props - The props passed to the component.
 * @returns The JSX code for the 404 page.
 */
const Pages404 = () => {
  const { t } = useTranslation();
  return (
    /**
     * Renders a page for when a requested page is not found.
     * @returns {React.Fragment} - The rendered page component.
     */
    <React.Fragment>
      <div className="account-pages nofoundPage">
        <Container>
          <Row className="justify-content-center">
            <Col
              lg="12"
              className="text-center d-flex justify-content-center pageNotFoundLogo"
            >
              <div className="fullRowStyle">
                <div className="leftContainStyle">
                  <div className="oopsTextStyle">{t("OOPS")}</div>
                  <h1 className="text-center text-primary text-notfound">
                    {" "}
                    {t("PAGE_NOT_FOUND")}
                  </h1>
                  <div>{t("LOOKS_LIKE_YOU_GOT_LOST_IN_THE_JUNGLE")}</div>
                </div>
                <div className="rightImageStyle">
                  <img
                    src={Constant.NODATAIMAGE_URL.ERROR_IMAGE}
                    alt="App Logo"
                    className="img-fluid"
                  />
                </div>
              </div>
            </Col>
            <br />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Pages404;
